<template>
  <div
    class="basic_download_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    @dblclick="changeStyle('style')"
    :style="{'--theme_color': theme_color}"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="changeStyle('animation')"
        v-if="this.$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index" v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
    </div>
    <my_title_index :title="widgets_infor.title"></my_title_index>
    <div class="file_empty" v-if="listArr.fileList.length <= 0 && $store.state.app.view_pattern === 'pc'">
      <i class="empty_tips_img"></i>
      <div class="empty_tips_text">{{$t('widgets_basic_download_index_511')}}</div>
      <el-button size="medium" type="primary" @click="add_file">{{$t('widgets_basic_download_edit_504')}}</el-button>
    </div>
    <my_mb_empty_tips v-if="listArr.fileList.length <= 0 && $store.state.app.view_pattern === 'mb'"></my_mb_empty_tips>
    <div class="file_download_container" v-else-if="listArr.moduleStyle === 0">
      <div class="file_item" v-for="item in fileList" :key="item.id">
        <div class="file_item_message">
          <div class="file_item_title" :style="fontStyle">{{ item.fileName }}</div>
          <div class="file_item_size" :style="fontStyle">{{ (item.fileSize / 1024).toFixed(1) }}KB</div>
        </div>
        <div class="file_item_download" @click="openEditForm($event)">
          <a
            class="file_download"
            :href="`javascript:download('${item.filePath}','${item.fileName}');`"
            target="_self"
          >{{$t('router_index_69')}}</a>
        </div>
      </div>
    </div>
    <div
      class="file_download_container2"
      :class="{view_pattern_mb: $store.state.app.view_pattern === 'mb'}"
      v-else-if="listArr.moduleStyle === 1">
      <div class="file_item_wrap" v-for="item in fileList" :key="item.id">
        <div class="file_item">
          <div class="file_icon">
            <img v-if="/pdf/i.test(item.fileFormat)" src="@/assets/image/icon_pdf.png" />
            <img v-else-if="/doc.?/i.test(item.fileFormat)" src="@/assets/image/icon_docx.png" />
            <img v-else-if="/ppt.?/i.test(item.fileFormat)" src="@/assets/image/icon_pptx.png" />
            <img v-else-if="/xl.{1,2}/i.test(item.fileFormat)" src="@/assets/image/icon_xlsx.png" />
            <img v-else-if="/(rar|zip|gz)/i.test(item.fileFormat)" src="@/assets/image/icon_rar.png" />
            <img v-else-if="/mp4/i.test(item.fileFormat)" src="@/assets/image/icon_video.png" />
            <img
              v-else-if="/(jpg|jpeg|gif|png|svg)/i.test(item.fileFormat)"
              src="@/assets/image/icon_img.png"
            />
            <img v-else src="@/assets/image/icon_unkonw.png" />
          </div>
          <div class="file_item_message">
            <div class="file_item_title" :style="fontStyle">{{ item.fileName }}</div>
            <div class="file_item_size" :style="fontStyle">{{ (item.fileSize / 1024).toFixed(1) }}KB</div>
          </div>
          <div class="file_item_download" @click="openEditForm($event)">
            <a
              class="file_download"
              :href="`javascript:download('${item.filePath}','${item.fileName}');`"
              target="_self"
            >
              <img class="icon_download" src="@/assets/image/icon_download.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <my_page_index
      v-if="pc_widgets_infor.page.radioValue && listArr.fileList.length > 0"
      :page="pc_widgets_infor.page"
      :currentPage.sync="currentPage"
      :total="listArr.fileList.length"
    ></my_page_index>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { basic_download_new_style } from "@/base/widgets_data_compatible";
export default {
  name: 'basic_download_index',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    theme_color () {
      return this.$store.state.myRender.common.theme_color
    },
    widgets_infor () {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor'];
    },
    pc_widgets_infor () {
      return this.module.data.pc_widgets_infor;
    },
    listArr () {
      return this.module.data.listArr
    },
    fontStyle () {
      let pc_widgets_infor = this.module.data['pc_widgets_infor'];
      let fontStyle = {
        ...pc_widgets_infor.font[pc_widgets_infor.font.radio_val],
        fontSize: pc_widgets_infor.font[pc_widgets_infor.font.radio_val].fontSize + 'px'
      };
      return fontStyle;
    },
    fileList () {
      return this.templet.pageShowList(this.listArr.fileList, this.pc_widgets_infor.page, this.currentPage)
    }
  },
  data () {
    return {
      isHover: false,
      currentPage: 1
    };
  },
  created() {
      const listArr = this.module.data.listArr;
      const data = basic_download_new_style();
      if (typeof listArr.download_form == "undefined") {
        this.$set(listArr, "download_form", data.download_form);
      }
      // 设置留言表单的默认值
      if (listArr.download_form.custom.value == "" && this.$store.state.app.formList.length > 0) {
        this.$set(listArr.download_form.custom, "value", this.$store.state.app.formList[0].id);
        this.$set(listArr.download_form.default, "value", this.$store.state.app.formList[0].id);
      }
  },
  mounted () {
  },
  methods: {
    getForm(id, data) {
      let obj = {};
      if (id !== "") {
        for (let i = 0; i < data.length; i++) {
          if (data[i].value === id) {
            obj = data[i];
            break;
          }
        }
      }
      return obj;
    },
    openEditForm($event) {
      if(this.templet.amp_no_make()){
        return
      }
      if(this.listArr.download_form.radio_val == 'custom' && this.listArr.download_form.custom.value !== '') {
          $event.preventDefault();
          this.templet.clickTime(() => {
          if (this.listArr.download_form.custom.value !== "") {
            let form = this.getForm(
              this.listArr.download_form.custom.value,
              this.$store.state.app.formList
            );
            this.$store.commit("app/set_submit_form_isShow", true);
            this.$store.commit("app/set_form", form);
          }
        });
      }
    },
    module_isHover (val) {
      this.isHover = val;
    },
    changeStyle (tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    add_file () {
      let limt = 50 - this.listArr.fileList.length
      this.$store.commit('image_upload/set_fileType', this.$store.state.image_upload.TYPE_MY_FILE)
      this.$store.commit('image_upload/set_fileLimit', limt)
      this.$store.commit("image_upload/set_showTag", true)
       this.$store.commit("image_upload/set_isDownload", true)
      this.$store.commit("image_upload/set_limitMessage", i18n.t('widgets_basic_download_index_512'))
      this.$store.state.image_upload.imgFile = (e) => {
        let isFilter = false
        if (Array.isArray(e)) {
          e.map((item) => {
            let obj = {
              id: item.id,
              fileName: item.fileName,
              fileSize: item.fileSize,
              filePath: item.filePath,
              createTime: item.createTime,
              fileFormat: item.fileFormat,
              realFileFormat: item.fileFormat,
            }
            let isHave = false
            this.listArr.fileList.map((listItem) => {
              if (listItem.id === obj.id) {
                isHave = true
                isFilter = true
              }
            })
            if (!isHave) {
              this.listArr.fileList.push(obj)
            }
          })
        } else {
          let obj = {
            id: e.id,
            fileName: e.fileName,
            fileSize: e.fileSize,
            filePath: e.filePath,
            createTime: e.createTime,
            fileFormat: e.fileFormat,
            realFileFormat: item.fileFormat,
          }
          let isHave = false
          this.listArr.fileList.map((listItem) => {
            if (listItem.id === obj.id) {
              isHave = true
              isFilter = true
            }
          })
          if (!isHave) {
            this.listArr.fileList.push(obj)
          }
        }
        if (isFilter) {
          this.$message.warning(i18n.t('widgets_basic_download_edit_510'))
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";
.basic_download_index {
  // height: 100%;
  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
  .file_empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 90px 0;
    .empty_tips_img {
      display: block;
      width: 157px;
      height: 123px;
      margin: 0 auto 28px;
      background: url(~@/assets/image/default_icon.png) 0 0;
    }
    .empty_tips_text {
      margin-bottom: 28px;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .file_download_container {
    .file_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 9px 0 9px;
      height: 58px;
      border-bottom: 1px dashed #e7e7e7;
      background: #fff;
      font-size: 14px;
      .file_item_message {
        overflow: hidden;
        flex: 1;
        display: flex;
        justify-content: space-between;
        margin-right: 5.8%;
        width: 86%;
        .file_item_title {
          padding-right: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .file_item_size {
          padding-right: 10px;
          flex: 0 0 80px;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .file_item_download {
        flex: 0 0 80px;
        min-width: 80px;
        height: 34px;
        background: #f2f3f5;
        border-radius: 3px;
        text-align: center;
        box-sizing: border-box;
        padding: 0 10px;
        a {
          display: inline-block;
          line-height: 34px;
          color: #657180;
          text-decoration: none;
          font-size: 14px;
          font-weight: 400;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .file_download_container2 {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0 0 10px 0;
    .file_item_wrap {
      width: 31.6%;
      min-width: 175px;
      height: 100px;
      margin: 10px 0.7%;
      border: 1px solid rgba(240, 240, 240, 1);
      border-radius: 2px;
      display: flex;
      align-items: center;
      flex-shrink: 1;
      background: #fff;
      .file_item {
        width: 90%;
        height: 48px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .file_icon {
          flex: 0 0 48px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 48px;
          height: 48px;
          img {
            overflow: hidden;
            width: 100%;
            border-radius: 5px;
          }
        }
        .file_item_message {
          overflow: hidden;
          flex: 1;
          display: flex;
          flex-direction: column;
          width: 70%;
          margin: 20px 12px;
          .file_item_title {
            padding-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .file_item_size {
            padding-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .file_item_download {
          min-width: 48px;
          flex: 0 0 48px;
          height: 30px;
          background: rgba(242, 243, 245, 1);
          border-radius: 15px;
          text-align: center;
          .file_download {
            display: inline-block;
            width: 100%;
            height: 100%;
            font-size: 16px;
            color: #000;
            font-weight: bolder;
            line-height: 30px;
            .icon_download {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }
}
.pc_pattern {
  .file_item_download {
    &:hover {
      background: var(--theme_color) !important;
      a {
        color: #fff !important;
      }
    }
  }

}
.mb_pattern {
  .basic_download_index {
    .file_item_wrap {
      width: 92.6%;
      height: 76px;
      margin: 0 3.7%;
      border: none;
      border-bottom: 1px dashed rgba(240, 240, 240, 1);
      display: flex;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_download/index.vue